import React from 'react'
import { Circle } from '@mui/icons-material'
import { Grid } from '@mui/material'
import { isNil } from 'lodash'

const BRANCH = {
    MIGRATION_QUALITE: 'migration-qualite',
    QUALI_PREPROD: 'quali-preprod',
    PREPROD: 'preprod',
    PROD: 'prod',
    DEVELOP: 'develop',
    INTEGRATION: 'integration',
    UNKNOWN: 'inconnue',
    INCOHERENT: 'Incohérent',
}
const STATE = {
    OK: 'OK',
    KO: 'KO',
    WARNING: 'WARNING',
    EMPTY: 'EMPTY',
    INCOMPLETE: 'INCOMPLETE',
}
const VIGILANCE = {
    HIGH: 'high',
    MEDIUM: 'medium',
}
const CUSTOMER_STATUS = [
    { value: 1, label: <Grid container spacing={1} alignItems='center'><Circle sx={{ color: '#00b0f0', fontSize: '1rem' }} />Démarrage</Grid> },
    { value: 2, label: <Grid container spacing={1} alignItems='center'><Circle sx={{ color: '#92d050', fontSize: '1rem' }} />En cours</Grid> },
    { value: 3, label: <Grid container spacing={1} alignItems='center'><Circle sx={{ color: '#bfbfbf', fontSize: '1rem' }} />Archivé</Grid> },
]

// Lexique sensibilité commerciale (colonne sensibilitecommerce). null = non renseignée.
const COMMERCIAL_SENSITIVITY = [
    { value: 1, label: 'Très sensible', color: 'red' },
    { value: 2, label: 'Sensible', color: 'orange' },
]

const DISPLAY_MODE = {
    BACK: 'BACK',
    DB: 'DB',
    FRONT: 'FRONT',
    JOB: 'JOB',
}

const ALERT_RED = '#ff7f7f'
const ALERT_YELLOW = '#ffcc54'
const ALERT_GREEN = '#90ee90'

const getBranchColor = (branch) => {
    switch (branch) {
        case BRANCH.PREPROD: return '#0000FF'
        case BRANCH.PROD: return '#FF0000'
        case BRANCH.MIGRATION_QUALITE: return '#f2ed57' // jaune bière
        case BRANCH.QUALI_PREPROD: return '#800080'
        case BRANCH.DEVELOP: return '#008000'
        case BRANCH.INTEGRATION: return '#FFA756'
        case BRANCH.INCOHERENT: return '#000000'
        default: return '#808080'
    }
}

const getInstanceBranchGroup = (instance, services = []) => {
    const branch = instance.branch ?? BRANCH.UNKNOWN
    const hasIncoherentBranch = services.some(s => s.instance.id === instance.instanceId && !isNil(s.branch) && s.branch !== branch)
    return hasIncoherentBranch ? BRANCH.INCOHERENT : branch
}

const getStatusColor = (status) => {
    switch (status) {
        case STATE.KO:
            return ALERT_RED
        case STATE.OK:
            return ALERT_GREEN
        default:
            return ALERT_YELLOW
    }
}

const getInstanceColor = (instance, displayMode) => {
    switch (displayMode) {
        case DISPLAY_MODE.BACK:
            return getStatusColor(instance.statusBackend)
        case DISPLAY_MODE.DB:
            return getStatusColor(instance.statusDB)
        case DISPLAY_MODE.FRONT:
            return getStatusColor(instance.statusFrontend)
        case DISPLAY_MODE.JOB:
            return getStatusColor(instance.statusJob)
        default:
            return ALERT_RED
    }
}

export {
    BRANCH,
    STATE,
    VIGILANCE,
    CUSTOMER_STATUS,
    COMMERCIAL_SENSITIVITY,
    DISPLAY_MODE,

    getBranchColor,
    getInstanceBranchGroup,
    getInstanceColor,

    ALERT_GREEN,
    ALERT_YELLOW,
    ALERT_RED,
}